import styled from 'react-emotion'
import Colors from '../../../themes/Colors'
import { ResponsiveContainer } from '../styledComponents'
import { mobile } from '../../../utils/mixins'

export const IbCricketAtIplSection = styled('section')`
  background-color: ${Colors.darkTwoDefault};
  padding-top: 60px;
  padding-bottom: 60px;
  ${mobile} {
    padding-top: 40px;
    padding-bottom: 40px;
  }
`
export const Container = styled(ResponsiveContainer)``

export const PartnersStatsContainer = styled('div')`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  ${mobile} {
    display: flex;
    flex-direction: column;
    justify-content: center;
  }
`



// WEBPACK FOOTER //
// ./src/components/ExperimentalMarketing/IbCricketAtIpl2019/styledComponents.js